import { Route } from "react-router-dom";
import { useAuth } from "@/lib/auth";

import Dashboard from "@/pages/app/Dashboard";
import CoachHome from "@/pages/coach/CoachHome";
import Credits from "@/pages/app/Credits";
import Membership from "@/pages/app/Membership";
import Billing from "@/pages/app/Billing";
import Account from "@/pages/app/Account";
import CoachHub from "@/pages/app/CoachHub";
import BookProduct from "@/pages/app/BookProduct";
import MyBookings from "@/pages/app/MyBookings";
import SessionDetail from "@/pages/app/SessionDetail";
import SessionBooking from "@/pages/app/SessionBooking";
import CollabPackages from "@/pages/app/CollabPackages";
import CollabPackageDetail from "@/pages/app/CollabPackageDetail";
import CollabPackageSlots from "@/pages/app/CollabPackageSlots";
import CollabPackageBooked from "@/pages/app/CollabPackageBooked";
import DeepWithin from "@/pages/app/DeepWithin";
import DeepWithinCategory from "@/pages/app/DeepWithinCategory";
import Journal from "@/pages/app/Journal";
import Practices from "@/pages/app/Practices";
import PracticeRunner from "@/pages/app/practices/PracticeRunner";
import PracticeHistory from "@/pages/app/practices/PracticeHistory";
import Weva from "@/pages/app/weva/Weva";
import EvaChat from "@/pages/app/weva/EvaChat";
import WevaReports from "@/pages/app/weva/WevaReports";
import WevaReport from "@/pages/app/weva/WevaReport";
import EvaDigests from "@/pages/app/weva/EvaDigests";
import EvaDigestDetail from "@/pages/app/weva/EvaDigestDetail";
import Collaboration from "@/pages/app/Collaboration";
import GoalsList from "@/pages/app/goals/GoalsList";
import GoalWizard from "@/pages/app/goals/GoalWizard";
import GoalDetail from "@/pages/app/goals/GoalDetail";
import Breathwork from "@/pages/app/breathwork/Breathwork";
import BreathworkTechniques from "@/pages/app/breathwork/BreathworkTechniques";
import LibrarySession from "@/pages/app/breathwork/LibrarySession";
import BreathworkPlan from "@/pages/app/breathwork/BreathworkPlan";
import BreakoutHub from "@/pages/app/breakout/BreakoutHub";
import BreakoutSession from "@/pages/app/breakout/BreakoutSession";
import PanicFlow from "@/pages/app/panic/PanicFlow";
import PanicAnalytics from "@/pages/app/panic/PanicAnalytics";
import CopdFlow from "@/pages/app/copd/CopdFlow";
import CopdAnalytics from "@/pages/app/copd/CopdAnalytics";
import EditProfile from "@/pages/app/account/EditProfile";
import Settings from "@/pages/app/account/Settings";
import DataSharing from "@/pages/app/account/DataSharing";
import AccountConsentForms from "@/pages/app/account/ConsentForms";
import Safety from "@/pages/app/account/Safety";
import Help from "@/pages/app/account/Help";
import Support from "@/pages/app/account/Support";
import AccountWeeklyDigest from "@/pages/app/account/WeeklyDigest";
import PurchaseHistory from "@/pages/app/account/PurchaseHistory";
import RedeemPledge from "@/pages/app/account/RedeemPledge";
import BecomeCoach from "@/pages/app/account/BecomeCoach";
import Feed from "@/pages/app/feed/Feed";
import FeedDetail from "@/pages/app/feed/FeedDetail";
import Chats from "@/pages/app/messages/Chats";
import DirectMessage from "@/pages/app/messages/DirectMessage";
import SharedChat from "@/pages/app/messages/SharedChat";
import Circles from "@/pages/Circles";
import Notifications from "@/pages/Notifications";
import ShareCards from "@/pages/app/share/ShareCards";
import StoryWall from "@/pages/app/story/StoryWall";
import StoryWallInbox from "@/pages/app/story/StoryWallInbox";
import StoryWallMoment from "@/pages/app/story/StoryWallMoment";
import StoryMode from "@/pages/app/story/StoryMode";
import Collections from "@/pages/app/collections/Collections";
import CollectionDetail from "@/pages/app/collections/CollectionDetail";
import FocusTimer from "@/pages/app/FocusTimer";
import ConnectedBreath from "@/pages/app/ConnectedBreath";
import MethodPlayer from "@/pages/app/method/MethodPlayer";
import UnlockedMethods from "@/pages/app/UnlockedMethods";
import UnlockedPosts from "@/pages/app/UnlockedPosts";
import CollabHub from "@/pages/app/collab/CollabHub";
import CollabDiscover from "@/pages/app/collab/CollabDiscover";
import CollabOfferings from "@/pages/app/collab/CollabOfferings";
import CollabProjects from "@/pages/app/collab/CollabProjects";
import CollabProjectDetail from "@/pages/app/collab/CollabProjectDetail";
import CollabReviews from "@/pages/app/collab/CollabReviews";
import CollabChats from "@/pages/app/collab/CollabChats";
import BlockedUsers from "@/pages/app/BlockedUsers";
import SnapshotRequests from "@/pages/app/SnapshotRequests";

// Index of /app renders the coach home for coaches, the client dashboard otherwise.
function AppHome() {
  const { user } = useAuth();
  return user?.role === "coach" ? <CoachHome /> : <Dashboard />;
}

// Children of the /app layout route — client-facing surfaces.
export const clientRoutes = (
  <>
    <Route index element={<AppHome />} />
    <Route path="circles" element={<Circles />} />
    <Route path="coach-hub" element={<CoachHub />} />
    <Route path="book/:productId" element={<BookProduct />} />
    <Route path="bookings" element={<MyBookings />} />
    <Route path="session/:id" element={<SessionDetail />} />
    <Route path="session-booking" element={<SessionBooking />} />
    <Route path="collab-packages" element={<CollabPackages />} />
    <Route path="collab-package/:id" element={<CollabPackageDetail />} />
    <Route path="collab-package-slots/:bookingId" element={<CollabPackageSlots />} />
    <Route path="collab-package-booked/:bookingId" element={<CollabPackageBooked />} />
    <Route path="deep-within" element={<DeepWithin />} />
    <Route path="within/:category" element={<DeepWithinCategory />} />
    <Route path="journal" element={<Journal />} />
    <Route path="practices" element={<Practices />} />
    <Route path="practices/history" element={<PracticeHistory />} />
    <Route path="practices/:key" element={<PracticeRunner />} />
    <Route path="weva" element={<Weva />} />
    <Route path="weva/chat" element={<EvaChat />} />
    <Route path="weva/reports" element={<WevaReports />} />
    <Route path="weva/report/:id" element={<WevaReport />} />
    <Route path="weva/digests" element={<EvaDigests />} />
    <Route path="weva/digest/:id" element={<EvaDigestDetail />} />
    <Route path="collaboration" element={<Collaboration />} />
    <Route path="goals" element={<GoalsList />} />
    <Route path="goals/new" element={<GoalWizard />} />
    <Route path="goals/:id" element={<GoalDetail />} />
    <Route path="breathwork" element={<Breathwork />} />
    <Route path="breathwork/techniques" element={<BreathworkTechniques />} />
    <Route path="breathwork/session/:key" element={<LibrarySession />} />
    <Route path="breathwork/plan" element={<BreathworkPlan />} />
    <Route path="breakout" element={<BreakoutHub />} />
    <Route path="breakout/session" element={<BreakoutSession />} />
    <Route path="share-cards" element={<ShareCards />} />
    <Route path="story-wall" element={<StoryWall />} />
    <Route path="story-wall/inbox" element={<StoryWallInbox />} />
    <Route path="story-wall/moment/:id" element={<StoryWallMoment />} />
    <Route path="story-mode" element={<StoryMode />} />
    <Route path="collections" element={<Collections />} />
    <Route path="collections/:id" element={<CollectionDetail />} />
    <Route path="focus-timer" element={<FocusTimer />} />
    <Route path="connected-breath" element={<ConnectedBreath />} />
    <Route path="method/:id" element={<MethodPlayer />} />
    <Route path="unlocked-methods" element={<UnlockedMethods />} />
    <Route path="unlocked-posts" element={<UnlockedPosts />} />
    <Route path="collab" element={<CollabHub />} />
    <Route path="collab/discover" element={<CollabDiscover />} />
    <Route path="collab/offerings" element={<CollabOfferings />} />
    <Route path="collab/projects" element={<CollabProjects />} />
    <Route path="collab/project/:type/:id" element={<CollabProjectDetail />} />
    <Route path="collab/reviews" element={<CollabReviews />} />
    <Route path="collab/chats" element={<CollabChats />} />
    <Route path="blocked-users" element={<BlockedUsers />} />
    <Route path="snapshot-requests" element={<SnapshotRequests />} />
    <Route path="panic" element={<PanicFlow />} />
    <Route path="panic/analytics" element={<PanicAnalytics />} />
    <Route path="copd" element={<CopdFlow />} />
    <Route path="copd/analytics" element={<CopdAnalytics />} />
    <Route path="feed" element={<Feed />} />
    <Route path="feed/post/:id" element={<FeedDetail />} />
    <Route path="messages" element={<Chats />} />
    <Route path="messages/:userId" element={<DirectMessage />} />
    <Route path="shared-chat/:chatId" element={<SharedChat />} />
    <Route path="notifications" element={<Notifications />} />
    <Route path="credits" element={<Credits />} />
    <Route path="membership" element={<Membership />} />
    <Route path="billing" element={<Billing />} />
    <Route path="account" element={<Account />} />
    <Route path="account/profile" element={<EditProfile />} />
    <Route path="account/settings" element={<Settings />} />
    <Route path="account/data-sharing" element={<DataSharing />} />
    <Route path="account/consent" element={<AccountConsentForms />} />
    <Route path="account/safety" element={<Safety />} />
    <Route path="account/help" element={<Help />} />
    <Route path="account/support" element={<Support />} />
    <Route path="account/weekly-digest" element={<AccountWeeklyDigest />} />
    <Route path="account/purchases" element={<PurchaseHistory />} />
    <Route path="account/redeem" element={<RedeemPledge />} />
    <Route path="account/become-coach" element={<BecomeCoach />} />
  </>
);
